export const profileInfoThunkNames = {
    fetchProfileInfo: 'fetchProfileInfo',
    savePermissions: 'savePermissions',
};
